angular.module('app').controller('ContainerController', ContainerController);

function ContainerController($rootScope, $scope, $http) {
    $scope.deleteContainer = function (id) {
        if (confirm('Biztosan törlöd ezt a csomagolást?')) {
            var url = containerDeleteURL + '/' + id;
            $http.delete(url)
                .then(function successCallback(response) {
                    $('#row-' + id).transition('fade',250,function () {
                        $('#row-' + id).remove();
                    });

                }, function errorCallback(response) {
                    alert("Hiba történt törlés közben.");
                });
        }
    }
}
